import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    --color-primary: #5d2bff;
    --color-secondary: #5d2bff;

    --color-theme-100: #ffffff;
    --color-theme-200: #f6f6f9;
    --color-theme-300: #ebebee;
    --color-theme-400: #d7d7da;
    --color-theme-500: #b9b9bd;
    --color-theme-600: #89898e;
    --color-theme-700: #6d6d73;
    --color-theme-800: #5b5b61;
    --color-theme-900: #303037;

    --color-primary-200: rgba(93, 43, 255, 0.05);
    --color-primary-300: rgba(93, 43, 255, 0.1);
    --color-primary-400: rgba(93, 43, 255, 0.25);
    --color-primary-500: rgba(93, 43, 255, 0.5);
    --color-primary-600: rgba(93, 43, 255, 0.75);
    --color-primary-700: #5d2bff;
    --color-primary-800: #4a21cd;
    --color-primary-900: #32178b;

    --color-secondary-200: rgba(93, 43, 255, 0.05);
    --color-secondary-300: rgba(93, 43, 255, 0.1);
    --color-secondary-400: rgba(93, 43, 255, 0.25);
    --color-secondary-500: rgba(93, 43, 255, 0.5);
    --color-secondary-600: rgba(93, 43, 255, 0.75);
    --color-secondary-700: #5d2bff;
    --color-secondary-800: #4a21cd;
    --color-secondary-900: #32178b;

    --color-theme-transparent-200: rgba(36,36,76,0.04);
    --color-theme-transparent-300: rgba(48,48,55,0.1);
    --color-theme-transparent-400: rgba(48,48,55,0.2);
    --color-theme-transparent-500: rgba(48,48,55,0.34);
    --color-theme-transparent-600: rgba(48,48,55,0.57);
    --color-theme-transparent-700: rgba(48,48,55,0.7);
    --color-theme-transparent-800: rgba(48,48,55,0.8);

    --color-primary-opaque-300: #efeaff;
    --color-primary-opaque-400: #d6caff;

    --color-secondary-opaque-300: #efeaff;
    --color-secondary-opaque-400: #d6caff;

    --color-sucess-green: #64cd93;
    --color-pale-green: #c3e799;

    --color-yellow: #FDF196;
    --color-yellow-darker: #948D5D;
    --color-yellow-lighter: #EBD429;
    --color-orange: #FBBB75;
    --color-orange-darker: #916C43;
    --color-orange-lighter: #E99841;
    --color-beige: #EAC2AD;
    --color-beige-darker: #877064;
    --color-beige-lighter: #B98A72;
    --color-pink: #FBD6E7;
    --color-pink-darker: #917C86;
    --color-pink-lighter: #E4A1C0;
    --color-coral: #FF9C9C;
    --color-coral-darker: #945A5A;
    --color-coral-lighter: #DB4545;
    --color-purple-dirty: #C49CB6;
    --color-purple-dirty-darker: #715A69;
    --color-purple-dirty-lighter: #B16E9A;
    --color-purple: #BEACF9;
    --color-purple-darker: #6E6390;
    --color-purple-lighter: #9B86DF;
    --color-blue-aqua: #BDF7FD;
    --color-blue-aqua-darker: #6D8F92;
    --color-blue-aqua-lighter: #7BDDE7;
    --color-blue-pale: #BEEAFF;
    --color-blue-pale-darker: #6E8794;
    --color-blue-pale-lighter: #92BFD4;
    --color-blue-sky: #A0CBFD;
    --color-blue-sky-darker: #5C7592;
    --color-blue-sky-lighter: #568CCB;
    --color-turquoise: #B9E4E0;
    --color-turquoise-darker: #6B8482;
    --color-turquoise-lighter: #70BFB8;
    --color-green-pale: #C3E799;
    --color-green-pale-darker: #718658;
    --color-green-pale-lighter: #80C333;
    --color-green-olive-drab: #98B57C;
    --color-green-olive-drab-darker: #647157;
    --color-green-olive-drab-lighter: #819F65;
    --color-gray-silver: #DDDDDD;
    --color-gray-silver-darker: #808080;
    --color-gray-silver-lighter: #ACACAC;
    --color-gray: #CACACA;
    --color-gray-darker: #757575;
    --color-gray-lighter: #7D7D7D;

    --body-bg-main: rgb(244, 245, 247);
    --body-bg-main-transparent: rgba(244, 245, 247, 0);
    --page-paper-main: #ffffff;
    --border-primary: #d7d7da;

    --note-bg: #fff9f1;

    --shadow-primary-hover: 0 64px 64px 0 rgba(0, 0, 0, 0.1),
      0 32px 32px 0 rgba(0, 0, 0, 0.06), 0 16px 16px 0 rgba(0, 0, 0, 0.04),
      0 4px 4px 0 rgba(0, 0, 0, 0.04), 0 2px 2px 0 rgba(0, 0, 0, 0.04);
    --shadow-primary: 0 64px 64px 0 rgba(0, 0, 0, 0.06),
      0 32px 32px 0 rgba(0, 0, 0, 0.03), 0 16px 16px 0 rgba(0, 0, 0, 0.02),
      0 4px 4px 0 rgba(0, 0, 0, 0.02), 0 2px 2px 0 rgba(0, 0, 0, 0.02);

    --shadow-secondary: 0 4px 14px 0 rgba(0, 0, 0, 0.17);

    --shadow-tertiary: 0 4px 6px -2px rgba(0, 0, 0, 0.05),
      0 10px 15px -3px rgba(0, 0, 0, 0.1);
    --shadow-tertiary-hover: 0 4px 10px -2px rgba(0, 0, 0, 0.1),
      0 12px 20px -3px rgba(0, 0, 0, 0.2);

    --page-paper-main-shadow: rgba(
      255,
      255,
      255,
      0
    ); /* Shadow list shadow for page paper main */

    --modal-background: rgba(244, 245, 247, 0.6);

    --highlight-dark: rgba(0, 0, 0, 0.03);

    --input-background-color: #ffffff;

    --ai-gradient: linear-gradient(135deg, #4da2ed, #9f69e5, #ec43d8, #f72222);
    
    --ai-gradient-lighter: linear-gradient(
      135deg,
      rgba(77, 162, 237, 0.1),
      rgba(159, 105, 229, 0.1),
      rgba(236, 67, 216, 0.1),
      rgba(230, 10, 10, 0.1)
    );

    --red-alert: rgb(237, 97, 97);

    --warning: #ffcc6b;

    --only-white: #ffffff;

    --only-black: #000000;

    --ac-br-4: 4px;

    --ac-br-6: 6px;

    --ac-br-8: 8px;

    --ac-br-rounded: 999px;
  }

  .cupcake {
    --color-primary: #29bcdd;
    --color-secondary: #fe6fa7;

    --color-primary-200: rgba(41, 188, 221, 0.07);
    --color-primary-300: rgba(41, 188, 221, 0.12);
    --color-primary-400: rgba(41, 188, 221, 0.26);
    --color-primary-500: rgba(41, 188, 221, 0.52);
    --color-primary-600: rgba(41, 188, 221, 0.75);
    --color-primary-700: #29bcdd;
    --color-primary-800: #219fbb;
    --color-primary-900: #1a768b;

    --color-secondary-200: rgba(254, 111, 167, 0.07);
    --color-secondary-300: rgba(254, 111, 167, 0.13);
    --color-secondary-400: rgba(254, 111, 167, 0.27);
    --color-secondary-500: rgba(254, 111, 167, 0.52);
    --color-secondary-600: rgba(254, 111, 167, 0.75);
    --color-secondary-700: #fe6fa7;
    --color-secondary-800: #dd6091;
    --color-secondary-900: #ab496f;

    --color-primary-opaque-300: #e5f7fb;
    --color-primary-opaque-400: #c8eef6;

    --color-secondary-opaque-300: #ffecf4;
    --color-secondary-opaque-400: #ffd8e7;
  }

  .classic {
    --color-primary: #4182f2;
    --color-secondary: #4182f2;

    --color-primary-200: rgba(65, 130, 242, 0.07);
    --color-primary-300: rgba(65, 130, 242, 0.13);
    --color-primary-400: rgba(65, 130, 242, 0.26);
    --color-primary-500: rgba(65, 130, 242, 0.52);
    --color-primary-600: rgba(65, 130, 242, 0.75);
    --color-primary-700: #4182f2;
    --color-primary-800: #356bc8;
    --color-primary-900: #244a8a;

    --color-secondary-200: rgba(65, 130, 242, 0.07);
    --color-secondary-300: rgba(65, 130, 242, 0.13);
    --color-secondary-400: rgba(65, 130, 242, 0.26);
    --color-secondary-500: rgba(65, 130, 242, 0.52);
    --color-secondary-600: rgba(65, 130, 242, 0.75);
    --color-secondary-700: #4182f2;
    --color-secondary-800: #356bc8;
    --color-secondary-900: #244a8a;

    --color-primary-opaque-300: #e6effd;
    --color-primary-opaque-400: #cedffc;

    --color-secondary-opaque-300: #e6effd;
    --color-secondary-opaque-400: #cedffc;
  }

  .neon {
    --color-primary: #67ffc8;
    --color-secondary: #67ffc8;

    --color-theme-100: #000000;
    --color-theme-200: #31333e;
    --color-theme-300: #2b2d37;
    --color-theme-400: #1f2024;
    --color-theme-500: #6D6D73;
    --color-theme-600: #89898e;
    --color-theme-700: #b0b0b5;
    --color-theme-800: #dfdfe5;
    --color-theme-900: #ffffff;

    --color-primary-200: rgba(103, 255, 200, 0.05);
    --color-primary-300: rgba(103, 255, 200, 0.1);
    --color-primary-400: rgba(103, 255, 200, 0.25);
    --color-primary-500: rgba(103, 255, 200, 0.5);
    --color-primary-600: rgba(103, 255, 200, 0.75);
    --color-primary-700: #67ffc8;
    --color-primary-800: #a5ffdf;
    --color-primary-900: #d0fdec;

    --color-secondary-200: rgba(103, 255, 200, 0.05);
    --color-secondary-300: rgba(103, 255, 200, 0.1);
    --color-secondary-400: rgba(103, 255, 200, 0.25);
    --color-secondary-500: rgba(103, 255, 200, 0.5);
    --color-secondary-600: rgba(103, 255, 200, 0.75);
    --color-secondary-700: #67ffc8;
    --color-secondary-800: #a5ffdf;
    --color-secondary-900: #d0fdec;

    --color-theme-transparent-200: rgba(6,7,8,0.12);
    --color-theme-transparent-300: rgba(6,7,8,0.22);
    --color-theme-transparent-400: rgba(6,7,8,0.5);
    --color-theme-transparent-500: rgba(255,255,255,0.27);
    --color-theme-transparent-600: rgba(255,255,255,0.4);
    --color-theme-transparent-700: rgba(255,255,255,0.6);
    --color-theme-transparent-800: rgba(255,255,255,0.85);

    --color-primary-opaque-300: #3b4e51;
    --color-primary-opaque-400: #436b64;

    --color-secondary-opaque-300: #3b4e51;
    --color-secondary-opaque-400: #436b64;

    --body-bg-main: rgb(44, 46, 56);
    --body-bg-main-transparent: rgba(44, 46, 56, 0);
    --page-paper-main: #373a44;
    --border-primary: #1f2024;

    --note-bg: #464545;

    --shadow-primary-hover: 0 64px 64px 0 rgba(0, 0, 0, 0.2),
      0 32px 32px 0 rgba(0, 0, 0, 0.2), 0 16px 16px 0 rgba(0, 0, 0, 0.2),
      0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.2);
    --shadow-primary: 0 64px 64px 0 rgba(0, 0, 0, 0.1),
      0 32px 32px 0 rgba(0, 0, 0, 0.1), 0 16px 16px 0 rgba(0, 0, 0, 0.1),
      0 4px 4px 0 rgba(0, 0, 0, 0.1), 0 2px 2px 0 rgba(0, 0, 0, 0.1);

    --shadow-secondary: 0 4px 14px 0 rgba(0, 0, 0, 0.3);

    --shadow-tertiary: 0 4px 6px -2px rgba(0, 0, 0, 0.1),
      0 10px 15px -3px rgba(0, 0, 0, 0.15);
    --shadow-tertiary-hover: 0 4px 12px -2px rgba(0, 0, 0, 0.4),
      0 10px 30px -3px rgba(0, 0, 0, 0.5);

    --page-paper-main-shadow: rgba(
      55,
      58,
      68,
      0
    ); /* Shadow list shadow for page paper main */

    --modal-background: rgba(44, 46, 56, 0.7);

    --highlight-dark: rgba(0, 0, 0, 0.06);

    --input-background-color: #2c2e38;

    --only-white: #ffffff;

    --only-black: #000000;
  }

  html {
    color-scheme: light;
  }

  html {
    &.neon {
      color-scheme: dark;
    }
  }

  .ac-shadow,
  .ac-shadow--raised {
    &--lg {
      box-shadow: var(--shadow-primary);
    }
    &--sm {
      box-shadow: var(--shadow-tertiary);
    }
  }

  .ac-shadow--raised {
    &--lg {
      transition: box-shadow 0.3s;
      &:hover {
        box-shadow: var(--shadow-primary-hover);
      }
    }
    &--sm {
      transition: box-shadow 0.3s;
      &:hover {
        box-shadow: var(--shadow-tertiary-hover);
      }
    }
  }

  .ac-shadow-optimized--sm {
    position: relative;
    box-shadow: var(--shadow-tertiary);

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      box-shadow: var(--shadow-tertiary);
      opacity: 0;
      border-radius: var(--ac-br-6);
      transition: opacity 0.3s ease;
      z-index: -1;
    }

    @media (hover: hover) {
      &:hover::before {
        opacity: 1;
      }
    }
  }

  .ac-shadow-optimized--lg {
    position: relative;
    box-shadow: var(--shadow-primary);

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      box-shadow: var(--shadow-primary);
      opacity: 0;
      border-radius: var(--ac-br-8);
      transition: opacity 0.3s ease;
      z-index: -1;
    }

    @media (hover: hover) {
      &:hover::before {
        opacity: 1;
      }
    }
  }

  .ac-border-radius {
    &-4 {
      border-radius: var(--ac-br-4);
    }

    &-6 {
      border-radius: var(--ac-br-6);
    }

    &-8 {
      border-radius: var(--ac-br-8);
    }

    &-rounded {
      border-radius: var(--ac-br-rounded);
    }
  }


  // CSS Tooltip ::after content: data-tooltip

  .c-cooltip {
  position: relative;

    /*
      * Prefer scoped variables in this case.
      * This lines of CSS should be scoped too.
      */

    --cooltip-spacing: 0.5rem;
    --cooltip-padding: 0.25rem 0.625rem;
    --cooltip-max-width: 12.5rem;

    --cooltip-transition-duration: 0.15s, 0.1s, 0.15s;
    --cooltip-transition-delay: 0.6s;
    --cooltip-timing: ease, ease, cubic-bezier(0.39, 0.575, 0.565, 1);
  }

  .c-cooltip::after {
    /*
      * will-change is intended to be used as a last resort,
      * in order to try to deal with existing performance problems.
      * It should not be used to anticipate performance problems.
      * https://developer.mozilla.org/en-US/docs/Web/CSS/will-change
      *
      * will-change: transform, opacity
      */
    pointer-events: none;
    content: attr(data-tooltip);
    position: absolute;
    color: #fff;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.9);
    border-radius: 0.5rem;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.3;
    max-width: var(--cooltip-max-width);
    padding: var(--cooltip-padding);
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .c-cooltip--top::after {
    bottom: calc(100% + var(--cooltip-spacing));
    left: 50%;
    transform: scale(0.85) translateX(-50%);
    transform-origin: 0;
  }

  .c-cooltip--right::after {
    left: calc(100% + var(--cooltip-spacing));
    transform: scale(0.85);
  }

  .c-cooltip--bottom::after {
    top: calc(100% + var(--cooltip-spacing));
    left: 50%;
    transform: scale(0.85) translateX(-50%);
    transform-origin: 0;
  }

  .c-cooltip--left::after {
    right: calc(100% + var(--cooltip-spacing));
    transform: scale(0.85);
  }

  /*
  * Make sure that disabled and aria pressed
  * items do not have tooltips available.
  */
  .c-cooltip:disabled::after,
  [aria-pressed="true"]::after {
    display: none;
  }

  /*
  *
  * Only use hover when is available .
  * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/hover
  */
  @media (hover: hover) {
    /*
      * Here we maybe have a complex selector but actually it's not.
      * We simply asks here to show tooltip only on hover.
      * Focused elements (in this case, clicked elements) should hide the tooltip.
      */
    .c-cooltip--top:not(:focus):hover::after,
    .c-cooltip--bottom:not(:focus):hover::after {
      transition-property: opacity, transform;
      transition-duration: var(--cooltip-transition-duration);
      transition-delay: var(--cooltip-transition-delay);
      transition-timing-function: var(--cooltip-timing);
      transform: scale(1) translateX(-50%);
      opacity: 1;
    }

    /*
      *
      * This is not code duplication!
      * Transform properties are tricky to animate and values
      * are not the same depending on the tooltip position.
      *
      * Animating only one transform, eg. scale(1) will
      * override all previously set transforms, eg. translateY.
      * So we need to always chain them.
      * eg. transform: scale(1) translateY(-50%) etc...
      */

    .c-cooltip--right:not(:focus):hover::after,
    .c-cooltip--left:not(:focus):hover::after {
      transition-property: opacity, transform;
      transition-duration: var(--cooltip-transition-duration);
      transition-delay: var(--cooltip-transition-delay);
      transition-timing-function: var(--cooltip-timing);
      transform: scale(1);
      opacity: 1;
    }
  }

  .c-date-picker--calendar {
    width: 260px;
    padding: 16px 0px 8px 0px;
    margin: auto;
    background-color: var(--page-paper-main);
  }
`;
